/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$('.metafield_tabs-nav a').on('click', function (event) {
    event.preventDefault();
    
    $('.tab_active').removeClass('tab_active');
    $(this).parent().addClass('tab_active');
    $('.metafields_tab-stage > div').hide();
    $($(this).attr('attr-section')).show();
});

$('.metafield_tabs-nav a:first').trigger('click'); // Default

var rechargeCheckTO; // Related to Recharge sub scriptions

$(document).ready(function(){
  /** Adds in a smooth scroll to the review section **/
  $('body').on('click', '.write-review-button', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this)).offset().top-100},
      300
    );
  });


  /** Recharge subscriptions related **/
  // rechargeCheckTO = setInterval(function() {
  //   let rcOptions = jQuery('.rc_widget__option__selector');
  //   if(rcOptions.length > 0) {
  //     var subscribeAndSaveHTML = jQuery(rcOptions[0]).find('.rc-option__text').html();
  //     jQuery(rcOptions[0]).find('.rc-option__text').html("<b>" + subscribeAndSaveHTML + "</b>");
  //     var subcribeAndSavePriceHTML = jQuery(rcOptions[0]).find('.rc-option__price').html();
  //     jQuery(rcOptions[0]).find('.rc-option__price').html("<b style='color: #e7721b;'>" + subcribeAndSavePriceHTML + "</b>");
  //     // Append list of subscription benefits
  //     jQuery(rcOptions[0]).append("<ul style='margin: 0.5rem 0 0.5rem 1.5rem; text-wrap: wrap;'> <li>Free Shipping on all Subscription Orders</li> <li>Change or Cancel anytime</li> <li>Choose between 2, 3, 4, 6, or 8 week intervals</li> </ul>");      
  //     jQuery(rcOptions[0]).next().prepend("<b>Delivery every </b>");
  //     clearInterval(rechargeCheckTO); // Clear timeout      
  //   }
  // }, 1000);
  /** End Recharge Subscriptions Block**/

  // Code that adds 'Manage subscriptions' to header area
  // jQuery('.Header__Wrapper a[href="/account"]').before('<a href="/tools/recurring/get-subscription-access" class="Heading u-h6" style="margin-right: 1rem;">Manage Subscriptions<span class="Header__LinkSpacer">Manage Subscriptions</span></a>');
  jQuery('.Header__Wrapper a[href="/account"]').before('<a href="/a/subscriptions/" class="Heading u-h6" style="margin-right: 1rem;">Manage Subscriptions<span class="Header__LinkSpacer">Manage Subscriptions</span></a>');
});